var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAvatarLg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.27501 0.450012H70.65C72.675 0.450012 74.325 2.47501 74.325 4.12501V70.5C74.325 72.525 72.675 74.175 70.65 74.175H4.27501C2.25001 74.175 0.600006 72.15 0.600006 70.5V4.20001C0.600006 2.10001 2.25001 0.450012 4.27501 0.450012Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.45 27.3C24.45 27.225 24.45 27.9 24.825 28.5C25.125 29.175 25.8 29.775 26.925 30.075C27 30.525 27.3 31.5 27.75 32.775C28.425 34.425 29.55 36.3 31.35 37.725C31.5 37.875 33.3 39.6 36.375 39.6C37.725 39.6 39.225 39.3 41.025 38.475C41.025 38.475 42.15 37.875 43.425 36.525C44.625 35.175 45.975 33.075 46.575 30.15C46.875 30.15 47.25 30 47.775 29.7C48.45 29.25 49.05 28.575 49.275 27.225C49.275 27.225 49.275 26.55 48.975 25.725C48.825 25.35 48.6 24.975 48.3 24.675C48 24.45 47.625 24.225 47.25 24.15H47.325L47.925 20.4C48.375 14.55 44.325 13.05 44.325 13.05C44.25 11.1 42.525 9.89999 42.525 9.89999C39.225 7.94999 32.4 10.575 32.4 10.575C27.15 11.85 25.95 15.45 25.95 15.45C24.3 19.2 25.95 23.925 26.1 24.375C25.95 24.45 25.725 24.6 25.5 24.825C24.975 25.35 24.45 26.1 24.45 27.3Z",
    fill: "url(#paint0_linear_128_33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.825 44.4C51.075 43.875 50.175 43.425 49.2 42.9C49.125 42.9 49.125 42.825 49.05 42.825C48.825 42.75 48.6 42.6 48.375 42.525C46.425 41.775 44.55 41.175 42.6 40.875C41.775 41.55 41.1 41.925 41.1 41.925C39.3 42.75 37.8 43.05 36.45 43.05C33.3 43.05 31.575 41.325 31.425 41.175L31.2 40.95C28.875 41.4 26.925 41.925 25.8 42.3V42.225C25.8 42.225 25.275 42.375 24.6 42.75C22.5 43.725 18.225 46.275 16.8 51.375V59.1C16.8 59.1 29.775 67.5 49.05 62.175C47.1 60.075 45.9 57.375 45.9 54.375C46.05 50.025 48.375 46.35 51.825 44.4Z",
    fill: "url(#paint1_linear_128_33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.775 48.675H52.8V62.25H62.775V48.675Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.375 44.4C51.9 44.4 47.4 48.9 47.4 54.375C47.4 59.85 51.9 64.35 57.375 64.35C62.85 64.35 67.35 59.85 67.35 54.375C67.35 48.9 62.925 44.4 57.375 44.4ZM61.95 55.05H58.5V58.575C58.5 59.025 58.2 59.325 57.825 59.325C57.375 59.325 57.15 58.95 57.15 58.575V55.05H53.625C53.175 55.05 52.875 54.75 52.875 54.375C52.875 54 53.25 53.7 53.625 53.7H57.15V50.175C57.15 49.725 57.45 49.425 57.825 49.425C58.275 49.425 58.5 49.8 58.5 50.175V53.7H62.025C62.475 53.7 62.775 54 62.775 54.375C62.775 54.75 62.475 55.05 61.95 55.05Z",
    fill: "#591E71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_128_33",
    x1: 24.45,
    y1: 24.3897,
    x2: 49.275,
    y2: 24.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_128_33",
    x1: 16.8,
    y1: 52.4091,
    x2: 51.825,
    y2: 52.4091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.79233e-9,
    stopColor: "#FC8162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF406F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarLg);
export default __webpack_public_path__ + "static/media/user_avatar_lg.da9c119e9003f5e5000043719b2c76e1.svg";
export { ForwardRef as ReactComponent };